namespace $.$$ {
	$mol_style_define( $shm_hitalama_skills, {
		List: { width: '22rem', flex: { basis: '22rem', grow: 0, shrink: 0 } },
	})
}
